/* eslint-disable sonarjs/no-collapsible-if */
import { NOT_NUMBER_REGEXP, checkboxValueToBooleanFilter, maxLengthFilter, stringToNullableNumberFilter, textFilter } from '@sofology/sofologycomponents';

import { PropertyDescriptionTypes } from 'models';
import { toStringFilter, toNullableNumberFilter } from './formFilters';
import { DynamicControlFilterType } from './formHelperAdditionalData';
import { isBooleanProperty, isNumberableSelectProperty, isNumberProperty, isStringProperty } from './propertyTypeHelper';

export function getControlFilters(property: PropertyDescriptionTypes): DynamicControlFilterType[] {
    let filters: DynamicControlFilterType[] = [];

    if (isNumberableSelectProperty(property)) {
        return filters = [stringToNullableNumberFilter()];
    }

    if (isNumberProperty(property)) {
        filters = [toStringFilter(), textFilter(NOT_NUMBER_REGEXP, ''), toNullableNumberFilter()];
    }

    if (isStringProperty(property)) {
        if (property.forbiddenCharsPattern) {
            filters.push(textFilter(new RegExp(property.forbiddenCharsPattern, 'g'), ''));
        }

        if (property.maxLength) {
            filters.push(maxLengthFilter(property.maxLength));
        }
    }

    if (isBooleanProperty(property)) {
        filters = [checkboxValueToBooleanFilter()];
    }

    return filters;
}